import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GetCapacityReportQuery } from './graphql/generated/ala-backend.service';
import { Mutable } from './graphql/utilities/to-mutable';

export type SuccessOrErrorType = {
  success: boolean;
  error?: string;
  context?: unknown;
};
type CapacityReportType = Mutable<GetCapacityReportQuery['capacityReport']>;
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private drawerClosedSubject = new Subject<void>();

  drawerClosed$: Observable<void> = this.drawerClosedSubject.asObservable();
  timeoutInterval: number | undefined;

  notifyDrawerClosed() {
    this.drawerClosedSubject.next();
  }

  capacityReportDataEntry = signal<CapacityReportType | undefined>(undefined);

  dataEntrySubmittedSignal = signal<SuccessOrErrorType | undefined>(undefined);

  isProgressIndicator = signal<boolean>(false);
  progressIndicatorMessage = signal<string>('All');

  loadConfig(interval: number) {
    this.timeoutInterval = interval;
  }
}
